import { __extends } from "tslib";
import { GetPublicAccessBlockOutput, GetPublicAccessBlockRequest } from "../models/index";
import { deserializeAws_restXmlGetPublicAccessBlockCommand, serializeAws_restXmlGetPublicAccessBlockCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetPublicAccessBlockCommand = /** @class */ (function (_super) {
    __extends(GetPublicAccessBlockCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetPublicAccessBlockCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetPublicAccessBlockCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetPublicAccessBlockRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetPublicAccessBlockOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetPublicAccessBlockCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlGetPublicAccessBlockCommand(input, context);
    };
    GetPublicAccessBlockCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlGetPublicAccessBlockCommand(output, context);
    };
    return GetPublicAccessBlockCommand;
}($Command));
export { GetPublicAccessBlockCommand };
//# sourceMappingURL=GetPublicAccessBlockCommand.js.map